module.exports = __webpack_public_path__ + "img/employment-icon.b9820fa5.svg";